import React, { useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import BudgetReport from "./budget";
import PoCapexReport from "./poCapex";
import PoMaster from "./master-po";
import GrnReport from "./grn";
import { getOfflineData } from "../../utils/offline-services";
import AdvancePayment from "./advance-payment";
import PurchaseRequestReport from "./pr";
import { isBaseUserRole } from "../../utils/common-utils";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const Reports = () => {
  const [value, setValue] = useState(isBaseUserRole() ? 1 : 0);
  const [financeValue, setFinanceValue] = useState(3);
  const [role, setRole] = useState("");
  const user = getOfflineData("user");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const financeHandleChange = (event, newValue) => {
    setFinanceValue(newValue);
  };
  const financeTabs = () => {
    return (
      <div>
        <div className="finance-v2-rm-pt tabs-section">
          <Box>
            <Tabs value={financeValue} onChange={financeHandleChange}>
              <Tab label="Master" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
              <Tab label="Budget" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
              <Tab label="Purchase Request" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
              <Tab label="Purchase Order" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
              <Tab label="GRN" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
              <Tab label="Advance Payment" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            </Tabs>
          </Box>
        </div>
        <TabPanel value={financeValue} index={0}>
          <PoMaster />
        </TabPanel>
        <TabPanel value={financeValue} index={1}>
          <BudgetReport />
        </TabPanel>
        <TabPanel value={financeValue} index={2}>
          <PurchaseRequestReport />
        </TabPanel>
        <TabPanel value={financeValue} index={3}>
          <PoCapexReport />
        </TabPanel>
        <TabPanel value={financeValue} index={4}>
          <GrnReport />
        </TabPanel>
        <TabPanel value={financeValue} index={5}>
          <AdvancePayment />
        </TabPanel>
      </div>
    );
  };
  const vendorTabs = () => {
    return (
      <div className="finance-v2-rm-pt">
        <div className="tabs-section">
          <Box>
            <Tabs value={value} onChange={handleChange}>
              <Tab label="Purchase Order" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
              <Tab label="GRN" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            </Tabs>
          </Box>
        </div>
        <TabPanel value={value} index={0}>
          <PoCapexReport hideApproverNames />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <GrnReport hideApproverNames />
        </TabPanel>
      </div>
    );
  };
  useEffect(() => {
    setRole(user?.role?.toUpperCase());
  }, [user]);
  return (
    <div>
      {role.includes("FINANCE") || role.includes("ADMIN") ? (
        financeTabs()
      ) : role.includes("VENDOR") ? (
        vendorTabs()
      ) : (
        <div className="finance-v2-rm-pt">
          <div className="tabs-section">
            <Box>
              <Tabs value={value} onChange={handleChange}>
                {/* Plain "user" has no PR access -- same gate as the home PR tab */}
                {!isBaseUserRole() && (
                  <Tab value={0} label="Purchase Request" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
                )}
                <Tab value={1} label="Purchase Order" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
                <Tab value={2} label="GRN" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
                <Tab value={3} label="Advance Payment" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
              </Tabs>
            </Box>
          </div>

          {!isBaseUserRole() && (
            <TabPanel value={value} index={0}>
              <PurchaseRequestReport />
            </TabPanel>
          )}
          <TabPanel value={value} index={1}>
            <PoCapexReport />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <GrnReport />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <AdvancePayment />
          </TabPanel>
        </div>
      )}
    </div>
  );
};

export default Reports;
